<template>
  <div class="fade-in">
    <h1 class="title">Edit Provider</h1>

    <form
      @submit.prevent="onSubmit"
      enctype="multipart/form-data"
      class="account-form"
    >
      <formly-form :form="form" :model="model" :fields="fields"></formly-form>
      <div class="field is-grouped mt2">
        <div class="control">
          <button :class="['button', 'is-primary', { 'is-loading': loading }]">
            Update
          </button>
        </div>
        <div class="control">
          <router-link
            :to="{ name: 'user-list', params: { id } }"
            class="button is-link is-small"
            >Cancel
          </router-link>
        </div>
      </div>
    </form>

    <vue-toastr ref="toastr"></vue-toastr>
  </div>
</template>

<script>
import VueToastr from "vue-toastr";
import ReferralDoctorService from "@/services/ReferralDoctorService";
import fields from "@/components/interview/DoctorFields";

export default {
  name: "interview-doctor-edit",

  mixins: [fields],

  props: ["id", "doctorId"],

  components: {
    VueToastr
  },

  data() {
    return {
      loading: false,
      model: {
        id: null,
        interviewId: this.id
      }
    };
  },

  methods: {
    onSubmit() {
      this.loading = true;
      ReferralDoctorService.update(this.model)
        .then(() => {
          this.loading = false;
          this.$router.push({
            name: "interview-providers",
            params: { id: this.$props.id }
          });
          this.$refs.toastr.s("The provider has been updated.");
        })
        .catch(errors => {
          this.loading = false;
          this.setErrors(errors);
          this.$refs.toastr.e("There was an error updating the provider.");
        });
    }
  },

  mounted() {
    const doctor = this.$store.getters["interview/getDoctor"](
      this.$props.doctorId
    );
    this.model = { ...this.model, ...doctor.attributes, id: doctor.id };
  }
};
</script>

<style lang="scss"></style>
